
<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="rect">
      <div class="about">
        如您未能通过其他用户提问解决您的疑问，您可以发起咨询提问，请告诉我们您的疑惑，我们将会为您解答！
        <div class="commentRect">
          <textarea v-model="commentBody" class="commentBody" rows="15" :maxlength="maxFont" />
          <div class="commnetFontNum">还可以输入{{ maxFont-nowFont }}字</div>
        </div>
      </div>

      <van-button type="info" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="OnAddQuestion">提交咨询</van-button>
    </div>
    <div class="EmptyRect" />
    <div class="downButton" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      title: '商品咨询',
      backurl: '/my/index',
      maxFont: 2048,
      nowFont: 0,
      commentBody: '',
      buttonLoading: false,
      commodityId: undefined
    }
  },
  watch: {
    commentBody(newValue, oldValue) {
      this.nowFont = newValue.length
      // this.formData.body = newValue
    }
  },
  created() {
    this.commodityId = this.$route.params.id
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    OnAddQuestion() {
      if (!this.commentBody || this.nowFont < 10) {
        MyNotify('error', '请至少填写10个字的咨询描述!')
        return
      }
      this.buttonLoading = true
      request({
        url: '/Store/addShopCommodityQA',
        method: 'post',
        data: {
          commodityId: this.commodityId,
          body: this.commentBody
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '提交成功!')
        this.$router.go(-1)
      })
    }
  }
}
</script>
<style scoped>
.rect{
    margin: 1em;
    border-radius: 0.5em;
    overflow: hidden;

    background-color: #fff;
    border-bottom: 1px solid #dadada;
}
.rect .about{
  padding: 1em;
}
.rect .score{
    margin-top: 0.6em;
}
.rect .commentRect{
    margin-top: 1em;
    border: 1px solid #cacaca;
    padding: 0.5em;
}
.rect .commentBody{
    width: 99%;
    resize: none;
    border: none;
}
.rect .commnetFontNum{
    text-align: right;
    font-size: 0.7em;
    color: #999;
}
</style>

